module.exports = __webpack_public_path__ + "media/images/user/favicons/icon-32x32-a3678f6bd7a181aebcc5c35a971991ee.png";